(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function mount(scope = document) {
    scope.querySelectorAll('[data-rs-motion]').forEach(figure => {
      const button = figure.querySelector('[data-motion-toggle]');
      const image = figure.querySelector('img');
      if (!button || !image || button.dataset.mounted) return;
      button.dataset.mounted = 'true';
      button.hidden = false;
      function setPlaying(playing) {
        image.src = playing ? image.dataset.motion : image.dataset.still;
        button.setAttribute('aria-pressed', String(playing));
        button.textContent = playing ? button.dataset.pause : button.dataset.play;
      }
      button.addEventListener('click', () => setPlaying(button.getAttribute('aria-pressed') !== 'true'));
      setPlaying(!reducedMotion.matches);
    });
  }
  reducedMotion.addEventListener('change', event => {
    if (!event.matches) return;
    document.querySelectorAll('[data-rs-motion] [data-motion-toggle][aria-pressed="true"]').forEach(button => button.click());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
